import { render, staticRenderFns } from "./PlaceOptions.vue?vue&type=template&id=34940b8a&scoped=true&"
import script from "./PlaceOptions.vue?vue&type=script&lang=js&"
export * from "./PlaceOptions.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOptions.vue?vue&type=style&index=0&id=34940b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34940b8a",
  null
  
)

export default component.exports